<template>
  <div class="modal-backdrop">
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-11 p-0 borderadius12">
      <div class="modal-content postmodalcontent borderadius12">
        <!-- <div class="modal-header">          
          <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel"></h5>  
          <button type="button" class="closebtn" @click="close" data-dismiss="modal" aria-label="Close">&times;
          </button>
        </div> -->
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <img src="../assets/information.gif" class="col-3 img-fluid mx-auto" alt=""> -->
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Currently system is under regular maintenance</span>
            <span class="mt-1 proximanova fontsize16 black60">please try after 30 minutes.</span>
            <button class="backgroundcolor3 white bordernone borderradius20 proximanova mt-4 p-1" @click="close" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default{
  
   data() {
    return{
    }
  },
  props : [
  ],
  methods:{
    close() {
        this.$emit('closeAPIerrorModal');
    },
  },
   mounted() {
       var that = this;
       setTimeout(() => {
        that.close()   
    }, 5000);
  },

}

</script>

<style  scoped>

.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
    padding-top: 3%;
}
.modal-footer{
    background-color: rgba(0, 0, 0, 0.04);
}
.maincard {
  width: 100%;
}
.card {
  margin: auto !important;
}
.labelNames{
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
}
.card-header {
  border-bottom: none;
}
.postmodalcontent{
  border: none !important;
}
.labels {
  margin-bottom: .15rem;
}
.selectedLabel {
  color: #007AFF !important;
  opacity: 1;
}
button:active {
    outline: none;
    border: none;
}
.btn:focus{
  box-shadow: none;
}
.border-red{
  border: 1px solid red;
}
.modal-header{
  border: none;
}
.bodymodal11{
    height: 300px;
    overflow: auto;
}
.countrycode{
  width: 40%;
}
.bodymodal11::-webkit-scrollbar {
  display: none;
}
.loadingIcon{
  width: 34px;
  height: 34px;
}
select{
    width: 100%;
    padding: .6em;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
}
.coursedrop{
    border: 1px solid #21BD8C;
}
input{
    width: 100%;
    padding: .5em;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
}
input:focus{
    outline: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.bodymodal11 {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.closebtn {
  width: 30px;
  height: 30px;
  border:none;
  border-radius: 50%;
}
.closebtn:hover{
  /* background: none !important; */
  border: 1px solid black;
  border-radius: 50%;
}
.reportcard1{
  padding-left: 0 !important;
  padding-right: 0 !important;
  border: 0;
  border: 1px solid rgba(31,31,31,0.1);
  -webkit-box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  border-radius: 10px;
  padding: 0;
}
.reportcard11 {
  display: block;
  text-align: left;
   background:
rgba(255,255,255,1);

  color: #222;
  border-radius: 10px !important;
  padding: 20px;
}
.reportcard11:after {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  float: right;
}

.reportcard11.collapsed {
  background:
rgba(255,255,255,1);
  color: #007AFF;
}
.sign-up-button{
    background-color: #21BD8C;
    border-radius: 4px;
    color: white;
}
.sign-up-button:hover{
    color: white;
}
label:checked { 
  color: red;
 } 
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
@media screen and  (max-width : 600px){
  .card{
    margin-left: 4%;
    margin-top: 4%;
  }
  .loadingIcon{
    width: 32px;
    height: 32px;
  }
}
@media screen and  (min-width: 770px){
  .card{
    margin-left: 35%;
  }
}
@media screen and  (min-width: 600px) and (max-width : 768px){
  .card{
    margin-left: 15%;
  }
}
</style>